/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import {
    object, string, shape, array, bool, arrayOf,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { uid } from 'react-uid';
import ReactMarkdown from 'react-markdown';
import Typography from '@material-ui/core/Typography';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import withStyles from '@material-ui/core/styles/withStyles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import {
    ExpansionPanel,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
    QaListStyle,
} from '../style/QaListStyle';

const styles = (theme) => QaListStyle(theme);

class QaList extends PureComponent {
    constructor(props) {
        super(props);
        const { defaultCategoryValue } = this.props;
        this.state = {
            activeValue: defaultCategoryValue,
            accordionActive: null,
            categoryValue: defaultCategoryValue,
        };
    }

    handleChange = (event, newActiveValue) => {
        this.setState({ activeValue: newActiveValue, categoryValue: (event.target.value || newActiveValue) });
    };

    handleChangeExpansionPanel = (panel) => (event, newExpanded) => {
        this.setState({ accordionActive: ((newExpanded) ? panel : null) });
    };

    setExpansionPanel = (layoutItem, index) => {
        const { classes } = this.props;
        const { accordionActive } = this.state;
        return (
            <Grid item md={12} xs={12} className={classes.expansionContainer} key={uid(layoutItem, index)}>
                <ExpansionPanel expanded={accordionActive === index} onChange={this.handleChangeExpansionPanel(index)}>
                    <ExpansionPanelSummary aria-controls="faq-question-content" id={`faq-question-header-${index}`}>
                        <Grid container>
                            <Grid item md={11} xs={10}>
                                <Typography variant="body1" className={classes.expansionTitle}>
                                    <ReactMarkdown source={layoutItem.question} />
                                </Typography>
                            </Grid>
                            <Grid item md={1} xs={2} className={classes.addIcon}>
                                {(accordionActive === index) ? <RemoveCircleIcon /> : <AddCircleIcon />}
                            </Grid>
                        </Grid>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Grid item md={12} xs={12} className={classes.expansionDetails}>
                            <ReactMarkdown source={layoutItem.answer} />
                        </Grid>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            </Grid>
        );
    };

    getNormalLayoutQA = (layoutItem, index) => (
        <Grid container key={uid(layoutItem, index)}>
            <Grid item md={12} xs={10}>
                <Typography variant="body1">
                    <b>{layoutItem.question}</b>
                </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
                <ReactMarkdown source={layoutItem.answer} />
            </Grid>
        </Grid>
    );

    handelCategoryFaq = () => {
        const { layoutDescription, isCategory, accordion } = this.props;
        if (layoutDescription?.length === 0) return null;
        return layoutDescription.map((layoutItem, index) => {
            if (isCategory) {
                const {
                    key,
                    value,
                } = layoutItem;
                const {
                    categoryValue,
                } = this.state;
                return (
                    <Grid item md={12} xs={12} key={uid(layoutItem, index)}>
                        <Typography
                            component="div"
                            role="tabpanel"
                            hidden={key !== categoryValue}
                            id={`faq-tabpanel-${categoryValue}`}
                            aria-labelledby={`faq-tab-${categoryValue}`}
                        >
                            {value.map((faqItem, faqIndex) => (
                                (accordion) ? this.setExpansionPanel(faqItem, faqIndex) : this.getNormalLayoutQA(faqItem, faqIndex)
                            ))}
                        </Typography>
                    </Grid>
                );
            }
            return (accordion) ? this.setExpansionPanel(layoutItem, index) : this.getNormalLayoutQA(layoutItem, index);
        });
    }

    render() {
        const {
            classes, layoutDescription, categoryDescription, layoutTitle, identifyWidthObj,
        } = this.props;
        const {
            activeValue,
            categoryValue,
        } = this.state;
        const categoryLength = (categoryDescription && categoryDescription.length > 0);
        return (
            <Grid container className={classes.layoutBorder}>
                <Grid item md={12} xs={12} className={(categoryLength) ? '' : classes.marginBottom18}>
                    {layoutTitle?.indexOf('#') >= 0 ? (<div className={classes.layoutTitleBox}><ReactMarkdown source={layoutTitle} /></div>) : (<Typography variant="h5" className={classes.layoutTitle} gutterBottom>{layoutTitle}</Typography>)}
                </Grid>
                {(categoryLength)
                    && (
                        <Grid item md={12} xs={12} className={classes.expansionContainer}>
                            {(identifyWidthObj.isDesktop)
                                ? (
                                    <Tabs
                                        value={activeValue}
                                        indicatorColor="primary"
                                        textColor="primary"
                                        onChange={this.handleChange}
                                        aria-label="category"
                                        className={classes.tabs}
                                    >
                                        {categoryDescription.map((categoryItem) => (
                                            <Tab label={categoryItem?.label} key={uid(categoryItem?.value)} value={categoryItem?.value} />
                                        ))}
                                    </Tabs>
                                ) : (
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel id="category-select-outlined-label">Category</InputLabel>
                                        <Select
                                            labelId="category-select-outlined-label"
                                            id="category-select-outlined"
                                            value={categoryValue}
                                            onChange={this.handleChange}
                                            label="Category"
                                        >
                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>
                                            {categoryDescription.map((categoryItem) => (
                                                <MenuItem value={categoryItem?.value} key={uid(categoryItem?.value)}>{categoryItem?.label}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                )}
                        </Grid>
                    )}
                {(layoutDescription && layoutDescription.length > 0)
                    && (
                        this.handelCategoryFaq()
                    )}
            </Grid>
        );
    }
}

QaList.defaultProps = {
    categoryDescription: [],
    defaultCategoryValue: '',
};

QaList.propTypes = {
    classes: object.isRequired,
    categoryDescription: arrayOf(shape({
        label: string,
        value: string,
    })),
    layoutDescription: array.isRequired,
    layoutTitle: string.isRequired,
    isCategory: bool.isRequired,
    identifyWidthObj: shape({
        isMobile: bool.isRequired,
        isDesktop: bool.isRequired,
    }).isRequired,
    defaultCategoryValue: string,
    accordion: bool.isRequired,
};

export default withStyles(styles, { withTheme: true })(QaList);
